import { Plane } from "lucide-react";
import type { DashboardData, Trip } from "../../types";
import { money } from "../../lib/finance";
import { Private } from "../../components/Privacy";
import { useTripStats } from "../../hooks/use-trip-stats";
import BudgetProgressBar from "./BudgetProgressBar";

export interface TripBudgetRowProps {
  trip: Trip;
  data: DashboardData;
  onOpenTrip?: (id: string) => void;
}

export default function TripBudgetRow({ trip, data, onOpenTrip }: TripBudgetRowProps) {
  const stats = useTripStats(trip, data);
  if (!stats || trip.budget === null) return null;
  const spent = stats.totalSpendBudget;
  const budget = trip.budget;
  const remaining = budget - spent;
  const over = remaining < 0;
  const pct = budget > 0 ? Math.round((spent / budget) * 100) : 0;

  return (
    <div
      className={"budget-row" + (over ? " over" : "")}
      onClick={() => onOpenTrip?.(trip.id)}
      style={{ cursor: onOpenTrip ? "pointer" : "default" }}
    >
      <span className="budget-row-main">
        <span className="budget-row-owner">
          <Plane size={15} />
          <strong>{trip.name}</strong>
          <span className="budget-row-badge">Trip</span>
        </span>
        <span className={`budget-status-pill ${over ? "over" : "left"}`}>
          <Private>{money(Math.abs(remaining), stats.budgetCurrency)}</Private>
          <small>{over ? "over" : "left"}</small>
        </span>
      </span>
      <div className="budget-row-progress-line">
        <BudgetProgressBar spent={spent} amount={budget} />
        <span className="budget-row-figures">
          <Private>{money(spent, stats.budgetCurrency)}</Private>
          <i>/</i>
          {money(budget, stats.budgetCurrency)}
          <small className="budget-pct-text">({pct}%)</small>
        </span>
      </div>
    </div>
  );
}
